import { memo, useMemo } from 'react';

import type { EditorialContent, MediaImage } from '@cobalt/utilities';
import VideoPlayer from '@shared/VideoPlayer';

export type VideoPlayerOptions = {
  file?: string;
  id?: string;
  hlsStreamUrl?: string;
  title?: string;
  description?: string;
  section?: string;
  kind?: string;
  context?: string;
  sponsor?: string;
  imageUrl?: string;
  mainMedia?: MediaImage;
  autoPlayOnScroll?: boolean;
  minimizeOnScroll?: boolean;
  minimizeOnScrollMobile?: boolean;
  repeat?: boolean;
  mute?: boolean;
  autostart?: boolean;
  sharing?: boolean;
  sharingurl?: string;
  sharingtxt?: string;
  url?: string;
  publicationDate?: string;
  maxTimeAgo?: number;
  blockHighlights?: boolean;
  showTitle?: boolean;
  fullscreenOnClick?: boolean;
  unmuteOnFullscreen?: boolean;
  forceSquareOnMobile?: boolean;
  disableAutoPause?: boolean;
};

const App = ({ options }: { options: VideoPlayerOptions }) => {
  const teaser = useMemo(
    () =>
      ({
        ...options,
        classification: {
          kind: options.kind,
          section: options.section,
        },
      }) as EditorialContent,
    [options],
  );

  return (
    <VideoPlayer
      teaser={teaser}
      isAutoPlay={options.autoPlayOnScroll ? 'viewable' : options.autostart}
      isMuted={options.mute || options.autoPlayOnScroll}
      {...options}
    />
  );
};

export default memo(App);
